import { useSelector } from "react-redux";
import { useLocation } from "react-router";

import ExportToExcel from "./ExportToExcel";

export default function ExportToExcelContainer(props) {
  const location = useLocation();
  const grunndataFilterForm = useSelector(
    (state) => state.forms.grunndataFilterForm,
  );
  const aktorer = useSelector((state) => state.aktorer);
  const bybetjenter = useSelector((state) => state.bybetjenter);
  const farger = useSelector((state) => state.farger);
  const kjoretoyMerker = useSelector((state) => state.kjoretoyMerker);
  const kjoretoyTyper = useSelector((state) => state.kjoretoyTyper);
  const internkoderIleggelser = useSelector(
    (state) => state.internkoderIleggelser,
  );
  const internkoderMiljogebyr = useSelector(
    (state) => state.internkoderMiljogebyr,
  );
  const nasjoner = useSelector((state) => state.nasjoner);
  const overtredelseskoderIleggelser = useSelector(
    (state) => state.overtredelseskoderIleggelser,
  );
  const overtredelseskoderMiljogebyr = useSelector(
    (state) => state.overtredelseskoderMiljogebyr,
  );
  const rettekoder = useSelector((state) => state.rettekoder);
  const vedtakskoder = useSelector((state) => state.vedtakskoder);

  return (
    <ExportToExcel
      location={location}
      grunndataFilterForm={grunndataFilterForm}
      aktorer={aktorer}
      bybetjenter={bybetjenter}
      farger={farger}
      kjoretoyMerker={kjoretoyMerker}
      kjoretoyTyper={kjoretoyTyper}
      internkoderIleggelser={internkoderIleggelser}
      internkoderMiljogebyr={internkoderMiljogebyr}
      nasjoner={nasjoner}
      overtredelseskoderIleggelser={overtredelseskoderIleggelser}
      overtredelseskoderMiljogebyr={overtredelseskoderMiljogebyr}
      rettekoder={rettekoder}
      vedtakskoder={vedtakskoder}
      {...props}
    />
  );
}
